// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoItem_infoItem__2TpXk h1 {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: var(--white-40);\n}\n.infoItem_infoItem__2TpXk div {\n  display: flex;\n  margin-top: 4px;\n  font-size: 18px;\n  line-height: 21px;\n  font-weight: bold;\n}\n.infoItem_infoItem__2TpXk:last-child {\n  grid-column: 1/span 2;\n}", ""]);
// Exports
exports.locals = {
	"infoItem": "infoItem_infoItem__2TpXk"
};
module.exports = exports;
